// extracted by css-extract-rspack-plugin
export default {"formHeader":"_dcbb726e","formCopy":"_aa9494d4"};